import {ProductsEnum} from "@ferry/journey-services";
import * as React from "react";
import {Link} from "react-router-dom";
import {getAmountWithDecimalDigits} from "../../CommonFunctions";
import {WarningBanner} from "@ferry/portal-core";

interface IProps {
    amount?: number;
    multiProductPage?: boolean;
    policyNumber: string;
    product: ProductsEnum;
    propertyName?: string;
    // Map of invoice id and amount
    unpaidInstallmentIdToAmount: any;
    ncdImpactedClaim?: boolean;
    isDirectDebit?: boolean;
    reuseCard?: boolean;
}

export class OverdueInstalmentBanner extends React.Component<IProps> {


    constructor(props: any) {
        super(props);
        this.state = {}
    }

    public render(): React.ReactNode {
        const paymentPage: string = this.props.reuseCard ? "payOverdueInstalment" : "missedPolicyPayment";
        const unpaidInvoiceIds = Array.from(Object.keys(this.props.unpaidInstallmentIdToAmount));
        if (unpaidInvoiceIds.length === 2) {
            return (
                <div className="inner-container">
                    <WarningBanner wording={
                        <>
                            Your last 2 instalments are overdue and they must be paid separately:
                            <div>
                                <Link id="payNow"
                                      className="btn btn-white-dashboard"
                                      aria-label={"Pay Now"}
                                      state={{
                                          verifyCardFailed: false,
                                          product: this.props.product
                                      }}
                                      to={{
                                          pathname: `/dashboard/account/${paymentPage}/${this.props.policyNumber}/${unpaidInvoiceIds[0]}`,
                                      }}>
                                    {'Pay ' + getAmountWithDecimalDigits(this.props.unpaidInstallmentIdToAmount[unpaidInvoiceIds[0]]) + ' now '}
                                </Link>
                                for your 1st missed payment
                            </div>
                            <div>
                                <Link id="payNow"
                                      className="btn btn-white-dashboard"
                                      aria-label={"Pay Now"}
                                      state={{
                                          verifyCardFailed: false,
                                          product: this.props.product
                                      }}
                                      to={{
                                          pathname: `/dashboard/account/${paymentPage}/${this.props.policyNumber}/${unpaidInvoiceIds[1]}`,
                                      }}>
                                    {'Pay ' + getAmountWithDecimalDigits(this.props.unpaidInstallmentIdToAmount[unpaidInvoiceIds[1]]) + ' now '}
                                </Link>
                                for your 2nd missed payment
                            </div>
                        </>
                    }/>
                </div>
            )
        } else if (this.props.ncdImpactedClaim && !this.props.isDirectDebit) {
            return (
                <div className="inner-container">
                    <WarningBanner wording={
                        <>
                            Your last instalment of <span className="font-weight-bold">{getAmountWithDecimalDigits(this.props.amount)}</span> is overdue.
                            If you don’t pay the outstanding premium we may pass it to a debt collection agency and this may impact your credit rating.
                            <div>
                                <Link id="payNow"
                                      className="btn btn-white-dashboard"
                                      state={{
                                          verifyCardFailed: false,
                                          product: this.props.product
                                      }}
                                      to={{
                                          pathname: `/dashboard/account/${paymentPage}/${this.props.policyNumber}/${unpaidInvoiceIds[0]}`,
                                      }}>
                                    Pay {getAmountWithDecimalDigits(this.props.amount)} now
                                </Link>
                            </div>
                        </>
                    }/>
                </div>
            );
        } else if (this.props.multiProductPage) {

            return (
                <div className="inner-container">
                    <WarningBanner wording={
                        <>
                            Your last instalment of <span className="font-weight-bold">{getAmountWithDecimalDigits(this.props.amount)} </span>
                            for your {this.props.propertyName ?? 'policy'} is overdue.
                            Missing instalment payments can lead to your car policy being cancelled.
                            <div>
                                <Link id="payNow"
                                      className="btn btn-white-dashboard"
                                      aria-label={"Pay Now"}
                                      state={{
                                          verifyCardFailed: false,
                                          product: this.props.product
                                      }}
                                      to={{
                                          pathname: `/dashboard/account/${paymentPage}/${this.props.policyNumber}/${unpaidInvoiceIds[0]}`,
                                      }}>
                                    Pay the balance now
                                </Link>
                            </div>
                        </>
                    }/>
                </div>
            );
        } else {
            return (
                <div className="inner-container">
                    <WarningBanner wording={
                        <>
                            Your last instalment of <span className="font-weight-bold">{getAmountWithDecimalDigits(this.props.amount)} </span>is overdue.
                            Missing instalment payments can lead to your car policy being cancelled.
                            <div>
                                <Link id="payNow"
                                      className="btn btn-white-dashboard"
                                      state={{
                                          verifyCardFailed: false,
                                          product: this.props.product
                                      }}
                                      to={{
                                          pathname: `/dashboard/account/${paymentPage}/${this.props.policyNumber}/${unpaidInvoiceIds[0]}`,
                                      }}>
                                    Pay {getAmountWithDecimalDigits(this.props.amount)} now
                                </Link>
                            </div>
                        </>
                    }/>
                </div>
            );
        }
    }
}
